import url from '@/settings/urls';

export default value => {
  if (!value)
    value = '';

  return (value.includes('http') ? value : `${url.storage_path}${value}`)
};
